<template>
  <el-dialog :title="title" :visible.sync="dialogDetail" :close-on-click-modal="false" width="90%" center
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border :height="tableHeight" :key="tableKey">
        <el-table-column type="index" prop="date" width="55" label="序号" fixed></el-table-column>
        <el-table-column prop="incomeExpenseType" min-width="75" label="收支类型" fixed>
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.incomeExpenseType == 0 ? '收款' : '付款' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="flowItemId" min-width="130" label="现金流项目">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.flowItemName }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="itemName" min-width="90" label="项目名称">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.itemName }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="paymentCycle" min-width="90" label="收付款周期">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.paymentCycle }}</span>
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="invoiceStatus" min-width="80" label="开票情况">
          <template slot-scope="scope">
            <!-- 0：已开票 1：款到发货 2：预付款 -->
             <div>
               <span>{{ ['已开票' ,'款到发货','预付款'][scope.row.invoiceStatus] }}</span>
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="debtAmount" min-width="100" label="总欠款(万元)">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.debtAmount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" min-width="100" label="供应商">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.supplierName }}</span>
            </div>
          </template>
        </el-table-column>
        <template v-for="item in tableHeadList">
          <el-table-column :key="item.id" :label="item.name" min-width="110">
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.cycleAmounts[item.valueKey] }}</span>
              </div>
            </template>
          </el-table-column>
        </template>
        <el-table-column prop="paymentMethods" min-width="80" label="收支方式">
          <template slot-scope="scope">
            <div>
              <span>{{ ['现金' ,'承兑','现汇'][scope.row.paymentMethods] }}</span>
             </div>
            <!-- 0：现金 1：承兑 2：现汇 -->
          </template>
        </el-table-column>
        <el-table-column prop="predictedAmount" min-width="140" label="预估收支合计(万元)">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.predictedAmount }}</span>
             </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" width="100" label="备注">
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.remark }}</span>
             </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div slot="footer">
      <el-button @click="closeadd">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { findCashFlowItemList, detailList } from '@/api/common-signature'
export default {
  name: 'monthPlanDialog',
  components: {},
  data () {
    return {
      tableDataList: [],
      rules: {},
      orgTreeData: [],
      BMlist: [],
      searchForm: {
        pageNo: 1,
        pageSize: 50,
        yearMonthDate: ''
      },
      tableHeadList: [],
      detailForm: {
        pageNo: 1,
        pageSize: 200,
        monthlyPlanMasterId: '',
        cycleMasterId: '',
        incomeExpenseType: ''
      },
      tableHeight: 500,
      tableKey: 0,
      currentEditingRow: null, // 当前正在编辑的行
      isAnyRowEditing: false, // 是否有行正在编辑
      auditRemark: ''
    }
  },
  props: {
    title: {
      type: String
    },
    dialogDetail: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustTableHeight()
    })
  },
  created () {
    this.findCashFlowItemList(true)
    setInterval(function () {
      document.querySelectorAll('.el-cascader-node__label').forEach(el => {
        el.onclick = function () {
          if (this.previousElementSibling) this.previousElementSibling.click()
        }
      })
    }, 1000)
    this.detailList()
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      }, 200)
    })
  },
  watch: {
    tableHeadList: {
      handler (newVal) {
        if (newVal && newVal.length > 0 && this.tableDataList.length > 0) {
        // 当表头变化时，确保每行数据都有对应的动态列值
          this.tableDataList.forEach(row => {
            if (!row.cycleAmounts) {
              row.cycleAmounts = {}
            }
            newVal.forEach(header => {
              if (row.cycleAmounts[header.valueKey] === undefined) {
                this.$set(row.cycleAmounts, header.valueKey, '')
              }
            })
          })
        }
        this.$nextTick(() => {
          this.adjustTableHeight()
        })
        this.$nextTick(() => {
          this.tableKey += 1
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    adjustTableHeight () {
      // 基础高度
      let baseHeight = 600

      // 根据数据量调整
      const rowCount = this.tableDataList.length
      if (rowCount > 10) {
        baseHeight = 600
      }

      this.tableHeight = baseHeight
    },
    // 小星星
    addStar (obj) {
      if (obj.column.property == 'incomeExpenseType' || obj.column.property == 'flowItemId' || obj.column.property == 'itemName' || obj.column.property == 'supplierName' || obj.column.property == 'paymentMethods' || obj.column.property == 'paymentCycle') {
        return 'star'
      }
      if (obj.column.label && obj.column.label.includes('周')) {
        return 'star'
      }
    },
    detailList () {
      console.log(this.rowData)
      this.$set(this.detailForm, 'monthlyPlanMasterId', this.rowData.id)
      this.$set(this.detailForm, 'cycleMasterId', this.rowData.cycleMasterId)
      this.$set(this.detailForm, 'tenantFaction', this.rowData.tenantFaction)
      this.$set(this.detailForm, 'incomeExpenseType', this.rowData.incomeExpenseType)
      detailList(this.detailForm)
        .then(res => {
          console.log(res)
          this.tableHeadList = res.titleList || []

          if (res.pageInfo && res.pageInfo.list && res.pageInfo.list.length > 0) {
            // 处理数据，确保动态列的值正确绑定
            this.tableDataList = res.pageInfo.list.map(item => {
              // 确保 cycleAmounts 存在
              if (!item.cycleAmounts) {
                item.cycleAmounts = {}
              }

              // 将动态表头对应的值赋值给 cycleAmounts
              if (this.tableHeadList && this.tableHeadList.length > 0) {
                this.tableHeadList.forEach(header => {
                  // 如果返回的数据中有动态列的值，将其放入 cycleAmounts
                  if (item[header.valueKey] !== undefined) {
                    item.cycleAmounts[header.valueKey] = item[header.valueKey]
                  } else if (item.cycleAmounts[header.valueKey] === undefined) {
                    // 如果没有值，设置为空字符串
                    item.cycleAmounts[header.valueKey] = ''
                  }
                })
              }
              item.isEditing = false
              return item
            })
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    // 递归判断列表，把最后的children设为undefined
    sAttributeList (data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length < 1) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.sAttributeList(data[i].children)
        }
      }
      return data
    },
    findCashFlowItemList (flag) {
      findCashFlowItemList().then((res) => {
        if (res.length > 0) {
          this.orgTreeData = res
          if (flag) {
            this.currentData = {
              title: res[0].name,
              parentId: res[0].id
            }
          }
          let jsonARR = JSON.parse(JSON.stringify(this.orgTreeData))
          this.BMlist = this.sAttributeList(jsonARR)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    closeadd () {
      this.currentEditingRow = null
      this.isAnyRowEditing = false
      this.$emit('update:dialogDetail', false)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
